import { onConnect } from '@sonicgarden/onconnect';

onConnect('.js-limit-attachments', (input) => {
  const max = Number(input.dataset.maxAttachments);
  const message = input.dataset.maxAttachmentsMessage;

  input.addEventListener('change', () => {
    if (input.files && input.files.length > max) {
      alert(message);
      input.value = '';
      return;
    }
    document.querySelectorAll('.js-image-cache-input').forEach(el => el.remove());
  });
});
